const sortsOptions = ["Email", "Login", "Uprawnienia", "Imię", "Nazwisko"];

export const userTypes = ["Admin", "Zwykły użytkownik"];

export const userTypesforBackend = ["ADMIN", "USER"];

export default sortsOptions;
